exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color[data-v-ec04b570]{width:40px;height:40px}.color.active[data-v-ec04b570]{border-color:#4a90e2}.color-inside[data-v-ec04b570]{width:34px;height:34px;left:50%;top:50%;-webkit-transform:translate(-50%, -50%);-ms-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}\n", ""]);

// exports
